export enum enumPerfilAcceso {
    USUARIO,
    VENDEDOR,
    EMPRESA
}

export const globalConf = {
    app_version: '1.4.9',
    auditoriaActivada: true, //IMPORTANTE ACTIVALA CUANDO SE SUBA VERSIÓN!!
    //Cuando se realizan modificaciones en el indexDB, hay que cambiar la versión para que la actualice en los dispositivos
    indexDB_version: 8,

    paginaApiDefecto: -953,

    user_empresa: "rest_presencia@amsystem.es",
    pwd_empresa: "AMSYSTEM",

    url_api_erp: "https://servicio.ampresencia.com/",
    // url_api_erp: "https://servicio-beta.ampresencia.com/",
    //url_api_erp:"http://localhost:59094/",

    url_functions_firebase: "https://europe-west2-alo-suite.cloudfunctions.net",
    // url_functions_firebase: "https://europe-west2-alo-suite-beta.cloudfunctions.net",

    path_Token: "token",
    path_erp: "api/v2/erp",
    path_account_resetPassword: "api/Account/ResetPassword",
    path_account_confirmReset: "api/Account/ConfirmReset",
    path_test_empresas: "api/Administracion/TestEmpresa/",

    //url_api_alo:"https://servicios.alosuite.com/",
    path_Login: "api/Login",
    path_LoginToken: "api/login/token",
    path_AloEmpresas: "api/alo/empresas",
    path_LoginPass: "api/Account/EsNuevoUsuario",
    path_articulos: "api/Articulos",
    path_ResetPasword: "api/Account/ResetPassword",
    path_Parametros: "api/Parametros/Documentos/",

    path_firebase_peticionFirma: "/firmarPDF/peticionFirma",
    path_documentoFirma_ALO: "api/alo/documentos/firma/",

    paginasMenu: [
        {
            titulo: 'menu.inicio',
            url: 'home',
            icon: 'home-outline',
            perfiles: []
        },
        {
            titulo: 'menu.articulos',
            url: 'articulos',
            icon: 'cube-outline',
            perfiles: [enumPerfilAcceso.USUARIO, enumPerfilAcceso.VENDEDOR, enumPerfilAcceso.EMPRESA]
        },
        {
            titulo: 'menu.clientes',
            url: 'clientes',
            icon: 'people-outline',
            perfiles: [enumPerfilAcceso.USUARIO, enumPerfilAcceso.VENDEDOR, enumPerfilAcceso.EMPRESA]

        },
        {
            titulo: 'menu.proveedores',
            url: 'proveedores',
            icon: 'person-outline',
            perfiles: [enumPerfilAcceso.USUARIO, enumPerfilAcceso.VENDEDOR, enumPerfilAcceso.EMPRESA]

        },
        {
            titulo: 'menu.documentos_venta',
            url: 'documentos',
            icon: 'clipboard-outline',
            perfiles: [enumPerfilAcceso.USUARIO, enumPerfilAcceso.VENDEDOR, enumPerfilAcceso.EMPRESA]

        },
        {
            titulo: 'menu.documentos_compra',
            url: 'documentos-compra',
            icon: 'document-outline',
            perfiles: [enumPerfilAcceso.USUARIO, enumPerfilAcceso.VENDEDOR, enumPerfilAcceso.EMPRESA]

        },
        {
            titulo: 'menu.logOut',
            url: 'login',
            icon: 'log-in-outline',
            perfiles: [enumPerfilAcceso.USUARIO, enumPerfilAcceso.VENDEDOR, enumPerfilAcceso.EMPRESA]

        },
    ],

}

export enum enumNivelDetalle {
    BASICO = 'basico',
    AMPLIADO = 'ampliado',
    AVANZADO = 'avanzado'
}

export enum enumFormasPago {
    EFECTIVO = 0,
    GIRO30DIAS = 1,
    TRANSFERENCIA = 2,
    RECIBOALAVISTA = 3,
    CHEQUE = 4,
    TARJETA = 5,
    GIRO3060DIAS = 6,
    GIRO306090 = 7
}

export enum enumAplicacionIVA {
    IVA = 0,
    IVARECARGO = 1,
    EXENTO = 2
}

export enum enumModalidadFical {
    REGIMENGENERAL = 0,
    INTERCOMUNITARIO = 1,
    IMPORTACIONEXPORTACION = 2,
    REAGYP = 3,
    IPSI_IGIC = 8,
    Operaciones_NO_Sujetas_Reglas_Localizacion = 12,
    Operaciones_NO_Sujetas_OSS = 24,
    Operaciones_Sujetas_OSS = 25

}



export enum enumTipoEntidad {
    PERSONAFISICA = 0,
    PERSONAJURIDICA = 1
}

export enum enumMonedas {
    EUR = 0,
    PST = 1,
    BOL = 2,
    PSO = 3,
    DOP = 4,
    USD = 5,
    CLP = 6,
    COP = 7,
    PEN = 8,
    ARS = 9,
    DH = 10,
    BOB = 11
}

export enum enumTipoOperacion {
    VENTA = 0,
    COMPRA = 1,
    COMPRAVENTA = 2
}

export enum enumTipoDocumento {
    FAC = 0, //Factura
    PED = 1, //Pedido
    ALB = 2, //Albarán
    PRE = 3, //Presupuesto
    CON = 4, //Contrato
    PTC = 5,
    INV = 6, //Inventario
    BAJ = 7,
    TRA = 8, //Parte de trabajo
    FAB = 9, //Fabricación
    DES = 10,
    LIQ = 11, //Liquidación
}

export enum enumSegmentTipoDocumento {
    FAC = 0, //Factura
    PED = 1, //Pedido
    ALB = 2, //Albarán
    PRE = 3, //Presupuesto
    FACSIM = 99, //Factura Simplificada
}

export enum eTipoArticulo {
    PD = 0,
    SV = 1,
    AC = 2,
    CO = 3,//Conceptos contables
    TA = 4 //Tasas
}

export enum eTipoLineaMovimientos {
    NORMAL = 0,
    ANTICIPO = 1,
    TER = 2,
    DESGLOSEPAQUETE = 3,
    PORTES = 4,
    COSTES = 5,
    RETENCION = 6,
    OBSERVACIONES = 9
}

export enum eEstadoEntidad {
    SIN_ESTADO = 0,
    INSERTAR = 1,
    ACTUALIZAR = 2,
    ELIMINAR = 3,
    DETACHED = 4
}

export enum eTipoMovimiento {
    SalidasClientes = 0,
    EntradasProveedor = 1,
    SalidasTraspaso = 2,
    EntradasTraspaso = 3,
    SalidasSucursal = 4,
    EntradasSucursal = 5,
    SalidasFabricacion = 6,
    EntradasFabricacion = 7,
    Ajuste = 8,
    Inventario = 9,
    Autoconsumo = 10
}

export enum eRegimenFiscalDocs {
    Regimen_General = 0,
    Intracomunitario = 1,
    Importacion_Exportacion = 2,
    REAGYP = 3,
    Inversion_Sujeto_Pasivo = 4,
    Regimen_Especial_Bienes_Usados = 5,
    Regimen_Especial_Agencias_Viajes = 6,
    DUA = 7,
    IPSI_IGIC = 8,
    Regimen_Fiscal_Aduanero_ZonasFrancas = 10,
    Operaciones_Interiores_Exentas = 11,
    Operaciones_NO_Sujetas_Reglas_Localizacion = 12,
    Importacion_Exportacion_Asimiladas = 13,
    Operaciones_Interiores_NO_Sujetas = 14,
    Regimen_Especial_Oro_De_Inversion = 15,
    Regimen_Especial_Grupos_De_Entidades = 16,
    Otras_Operaciones_Exentas = 20
}

export enum eTipoModalidadFacturas {
    Normal = 0,
    Simplificada = 1,
    ParteCaja = 2,
    Resumen = 3,
    ReciboCompensacion = 6,
    OtrosJustificantesContables = 7,
    Contables = 8,
    Proforma = 9,
    SustitutivaDeSimplificada = 10,
    ContableSimplificada = 81,
    ContableResumen = 83,
    ContableReciboCompensacion = 86,
    ContableOtroJustificante = 87,
    ContableSustitutivaDeSimplificada = 88
}

export enum TipoDomicilio {
    Principal = 10,
    Envio = 11,
    Otros = 12,
    PuntoCompra = 13,
    FACE = 14
}

export enum eTipoEventoCalendario {
    NOTA = 0,
    LLAMADA = 1,
    OPORTUNIDAD = 2,
    TAREA = 3,
    EVENTO = 4
}

// En el archivo .ts
export enum eTipoCompra {
    ArrendamientosCanones = 0,
    CompraMercaderias = 1,
    DescuentosProntoPago = 2,
    DevolucionesCompras = 3,
    ElementosTransporte = 4,
    EquiposInformaticos = 5,
    GastosExcepcionales = 6,
    ImpuestoBeneficios = 7,
    Indemnizaciones = 8,
    OtrosGastosFinancieros = 9,
    OtrosInmovilizados = 10,
    OtrosServicios = 11,
    OtrosTributos = 12,
    PrimasSeguros = 13,
    Publicidad = 14,
    Rappels = 15,
    Reparaciones = 16,
    SSEmpresa = 17,
    ServiciosBancarios = 18,
    ServiciosProfesionales = 19,
    SueldosySalarios = 20,
    Suministros = 21,
    Transportes = 22,
    MateriasPrimas = 23,
    Suplidos = 24
}

export enum eTipoVentaProducto {
    VentaMercaderias = 0,
    ProductosTerminados = 1,
    EnvasesyEmbalajes = 2,
    Devoluciones = 3,
}

export enum eTipoVentaServicio {
    PrestacionServicios = 0,
    Subvenciones = 1,
    Arrendamientos = 2,
    ServiciosDiversos = 3,
    OtrosIngresosFinancieros = 4,
    IngresosExcepcionales = 5,
    Suplidos = 6,
    IngresosPorComisiones = 7
}


export enum eEstadoAgenda {
    NoIniciado = 0,
    Aplazado = 1,
    EnCurso = 2,
    Completado = 3,
    EsperandoTercero = 4
}

export enum ePrioridadAgenda {
    MasAlto = 0,
    Alto = 1,
    Normal = 2,
    Bajo = 3,
    MasBajo = 4
}

export enum eEstadoLlamada {
    Pendiente = 0,
    Realizada = 1,
    NoRealizada = 2
}

export enum eMotivoPerdida {
    //MotivoPerdida = 0,
    Desconocido = 0,
    OfertaEconomica = 1,
    OfertaVentajosa = 2,
    NoRequerimientos = 3
}

export enum eTomaContacto {
    //TomaContacto = 0,
    Autogenerado = 0,
    Campaña = 1,
    ClienteExistente = 2,
    Conferencia = 3,
    Empleado = 4,
    Exposicion = 5,
    Llamada = 6,
    MailRecibido = 7,
    Partners = 8,
    Recomendacion = 9,
    RelacionesPublicas = 10,
    SitioWeb = 11,
    Visitas = 12
}

export enum eClasificacion {
    //Clasificacion = 0,
    NecesitaAnalisis = 0,
    PropuestaValor = 1,
    TomaDecisiones = 2,
    Analisis = 3,
    CotizacionPropuestaPresupuesto = 4,
    NegoziacionRevision = 5,
    GanadaCerrada = 6,
    PerdidaCerrada = 7
}

export enum enumTelefono {
    Principal = 0,
    Trabajo = 2,
    Particular = 4,
    Fax = 3,
}

export enum enumEmail {
    Principal = 0,
    Particular = 1,
}

export enum eTipoGrupo {
    CL,//Cliente(compra)
    PR,//Proveedor(venta)
    IN,
    FA,
    DE,
    TR
}
export enum eModalidadArticulo {
    Normal = 0,
    Bono = 1,
    Actividad = 2,
    Escandallo = 3,
    ActividadesAlternativas = 4,
    Cuotas = 5,
    Paquetes = 6,
    UsuariosCloud = 7,
    Estancia = 8,
    TER = 9,
    ALMProducto = 10,
    Costes = 11,
    Combinado = 12,
    ManoObra = 13,
    Vehiculos = 14,
    Maquinarias = 15
}

export enum eEstadoActivacion {
    Todos = 0,
    Activos = 1,
    Desactivados = 2
}

export enum eOrdenacionDocumentos {
    SinOrden = 0,
    Id_ASC = 1,
    Id_DESC = 2,
    FechaDocumento_ASC = 3,
    FechaDocumento_DESC = 4,
}

export enum eOrdenacionTerceros {
    SinOrden = 0,
    Id_ASC = 1,
    Id_DESC = 2,
    Nombre_ASC = 3,
    Nombre_DESC = 4,
}

export enum eOrdenacionArticulos {
    SinOrden = 0,
    Id_ASC = 1,
    Id_DESC = 2,
    Nombre_ASC = 3,
    Nombre_DESC = 4,
}

export enum eModalidadPago {
    Efectivo = 0,
    Incobrable = 1,
    Cheque = 2,
    Transferencia = 3,
    Recibo = 4,
    Pagaré = 5,
    //Efecto = 6,
    Liquidación = 7,
    Tarjeta = 8,
    Factoring = 9,
    Confirming = 10,
    CreditoDoc = 11,
}

export enum eTipoCuentaCorriente {
    Caja = 0,
    Banco = 1,
}

export enum enumTipoMovimientoTesoreria {
    Cobro = "cobros",
    Pago = "pagos"
}

export enum eTipoFicheroTerceros {
    Cliente = 0,
    Proveedor = 1,
    Aplicador = 2,
    Asesor = 4,
    RepresentanteLegal = 5,
    Taxista = 6,
    Trabajador = 7,
    Vendedor = 8,
    Almacen = 9,
    Sucursal = 10,
    EntidadesAdministrativas = 11,
    Transportista = 12,
    AgenteTransporte = 13,
    Conductor = 14,
    Autorizado = 15,
    PuestoCompra = 16,
    Socio = 17,
    Productor = 18,
    Laboratorio = 19,
    SinDeterminar = 99
}

export enum eEstadosDocumento {
    Aparcado = 0,
    Cerrado = 1,
}

export enum eTipoSerie {
    Normal = 0,
    Rectificativa = 1,
    Anticipo = 2,
    Simplificada = 3,
    FacturaParteCaja = 4,
    Inventario = 5,
    ReciboCompensacion = 6,
    OtrosJustificantesContables = 7,
    RegimenEspecialBienesUsados = 8,
    FacturaResumen = 9,
    FacturaSustitutiva = 10
}
